module.exports = __webpack_public_path__ + "static/media/cheesybit.9d427658.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/svg/cheesybit.svg
// module id = 465
// module chunks = 0